import ServerDirections from '@/config/server-directions'
import { GuestType } from '@/entities/GuestType'

import { RequestService } from '@/services/request.service'
const requestService = new RequestService()

export class GuestTypeRequests {
  list () {
    const route = ServerDirections.GUEST_TYPES
    const method = 'get'
    function map (data) {
      return data.map(item => new GuestType(item))
    }
    return requestService.makePromise(route, method, {}, map)
  }
}
